import {SOCIAL_MEDIA_TYPES} from '../../../core/constants/actionTypes';

export const cntrlGetSharedToken = payload => ({
  type: SOCIAL_MEDIA_TYPES.CNTRL_GET_SHARED_TOKEN,
  payload,
});
